import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { ref, watch } from 'vue';
import Markdown from 'vue3-markdown-it';

interface ClaimDescriptionProps {
  description: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimDescription',
  props: {
    description: { default: '' }
  },
  setup(__props: any) {



const textElIsExpandable = ref(false);
const textElIsExpanded = ref(false);
const textEl = ref<HTMLElement | null>(null);
const markdown = ref<HTMLElement | null>(null);
const resizeObserver = new ResizeObserver(() => {
  if (textEl.value) {
    textElIsExpandable.value = textEl.value.clientHeight > 200;
  }
});

watch(textEl, (newValue) => {
  if (newValue) {
    resizeObserver.observe(newValue);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["campaign-description", { expandable: textElIsExpandable.value, expanded: textElIsExpanded.value }]),
    "data-test": "claim-description"
  }, [
    _createElementVNode("div", {
      ref_key: "textEl",
      ref: textEl,
      class: "campaign-description-text"
    }, [
      _createVNode(_unref(Markdown), {
        ref_key: "markdown",
        ref: markdown,
        source: __props.description
      }, null, 8, ["source"])
    ], 512),
    (textElIsExpandable.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (textElIsExpanded.value = !textElIsExpanded.value))
        }, [
          (!textElIsExpanded.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("+ Show All")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("− Show Less")
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})